// Script para manejar el campo personalizado de hotel
let customHotelInitialized = false;

document.addEventListener("turbolinks:load", function() {
    if (!customHotelInitialized) {
        initializeCustomHotelField();
    }
});

function initializeCustomHotelField() {
    if (customHotelInitialized) return;
    customHotelInitialized = true;
    
    // Intentar obtener los elementos necesarios
    const hotelSelect = document.getElementById('whichHotelSelect');
    const customHotelWrapper = document.querySelector('.custom-hotel-wrapper');
    const customHotelInput = document.getElementById('customHotelName');
    
    // Verificar si los elementos existen
    if (!hotelSelect) {
        console.error('No se encontró el elemento select de hotel (whichHotelSelect)');
        return;
    }
    if (!customHotelWrapper) {
        console.error('No se encontró el wrapper del campo personalizado (.custom-hotel-wrapper)');
        return;
    }
    if (!customHotelInput) {
        console.error('No se encontró el campo de texto personalizado (customHotelName)');
        return;
    }
    
    console.log('Todos los elementos encontrados, inicializando campo personalizado de hotel');
    
    // Función para verificar si se seleccionó "Otro/Other"
    function checkHotelSelection() {
        const selectedValue = hotelSelect.value;
        console.log('Selección de hotel cambiada:', selectedValue);
        
        // Verificar si el valor seleccionado es "Otro" o "Other"
        if (selectedValue === 'Otro' || selectedValue === 'Other') {
            console.log('Se seleccionó Otro/Other, mostrando campo personalizado');
            customHotelWrapper.style.display = 'block';
            customHotelInput.required = true;
        } else {
            console.log('No se seleccionó Otro/Other, ocultando campo personalizado');
            customHotelWrapper.style.display = 'none';
            customHotelInput.required = false;
            customHotelInput.value = '';
        }
    }
    
    // Verificar el estado inicial
    console.log('Verificando estado inicial del selector de hotel');
    checkHotelSelection();
    
    // Agregar evento de cambio
    console.log('Agregando evento change al selector de hotel');
    hotelSelect.addEventListener('change', checkHotelSelection);
    
    // Modificar el comportamiento del formulario al enviarse
    const form = hotelSelect.closest('form');
    if (form) {
        console.log('Formulario encontrado, agregando evento submit');
        form.addEventListener('submit', function(e) {
            const selectedValue = hotelSelect.value;
            console.log('Formulario enviado, valor seleccionado:', selectedValue);
            
            // Si se seleccionó "Otro/Other" y se ingresó un nombre de hotel personalizado
            if ((selectedValue === 'Otro' || selectedValue === 'Other') && customHotelInput.value.trim() !== '') {
                console.log('Usando valor personalizado:', customHotelInput.value.trim());
                // Usar el valor del campo personalizado como el valor del hotel
                hotelSelect.value = customHotelInput.value.trim();
            }
        });
    } else {
        console.error('No se encontró el formulario padre');
    }
    
    // Forzar una verificación inicial después de un breve retraso
    setTimeout(checkHotelSelection, 500);
}
